import React, { useEffect, useState } from "react";
import LocationItem from "./LocationItem";

export default function LocationsList({
  activeLocations,
  sectionData,
  onFocusedLocation,
}) {
  const [openedLocation, setOpenedLocation] = useState(null);

  const onOpenedLocation = (location) => {
    setOpenedLocation(openedLocation?.id === location.id ? null : location);
  };

  useEffect(() => {
    onFocusedLocation(openedLocation);
  }, [openedLocation]);

  useEffect(() => {
    setOpenedLocation(null);
  }, [activeLocations]);

  return (
    <div className="locations-list">
      {activeLocations.length === 0 && (
        <p>There are no locations matching your search.</p>
      )}

      <div className="locations-list__list">
        {activeLocations.map((location) => {
          return (
            <LocationItem
              key={location.id}
              location={location}
              sectionData={sectionData}
              openedLocation={openedLocation}
              onOpenedLocation={onOpenedLocation}
            />
          );
        })}
      </div>
    </div>
  );
}
